import i18n from '@/lang/i18n.js' // eslint-disable-line

class Validator {
  static regexSpecialChar = /[!¡?¿#(&)"@'`_|/+=*,;:%$<>ºª{}-]/

  static noSpecialChar (val) {
    return this.regexCharSpecial.test(val)
  }

  static names (rule, value, callback) {
    const regex = /^[a-zA-ZÀ-ÿ-'\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ-'\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ-'\u00f1\u00d1]+$/g
    // const regex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g
    if (rule.required) {
      if (!value || typeof value === 'undefined') {
        // console.log(`1 ${rule.field}: [${value}] obligado: [${rule.required}] regExp: [${i18n.t('loyalty.requireField')}]`)
        callback(new Error(i18n.t('loyalty.requireField')))
      } else {
        if (!regex.test(value)) {
          // console.log(`2 ${rule.field}: [${value}] obligado: [${rule.required}] regExp: [${i18n.t('loyalty.notAllowedCharacters')}]`)
          callback(new Error(i18n.t('loyalty.invalidFormat')))
        } else {
          callback()
        }
      }
    } else {
      if (value && typeof value === 'string' && !regex.test(value)) {
        // console.log(`3 ${rule.field}: [${value}] obligado: [${rule.required}] regExp: [${i18n.t('loyalty.notAllowedCharacters')}]`)
        callback(new Error(i18n.t('loyalty.invalidFormat')))
      } else {
        callback()
      }
    }
  }

  static gender (rule, value, callback) {
    if (rule.required) {
      if (!value || typeof value === 'undefined') {
        callback(new Error(i18n.t('loyalty.requireField')))
      } else {
        if (value === 'N') {
          callback(new Error(i18n.t('loyalty.requireField')))
        } else if (!(value === 'M' || value === 'V')) {
          console.log(`2 ${rule.field}: [${value}] obligado: [${rule.required}] regExp: [${i18n.t('loyalty.invalidFormat')}]`)
          callback(new Error(i18n.t('loyalty.invalidFormat')))
        } else {
          callback()
        }
      }
    } else {
      if (!(value === 'M' || value === 'V')) {
        console.log(`3 ${rule.field}: [${value}] obligado: [${rule.required}] regExp: [${i18n.t('loyalty.invalidFormat')}]`)
        callback(new Error(i18n.t('loyalty.invalidFormat')))
      } else {
        callback()
      }
    }
  }

  static maritalStatus (rule, value, callback) {
    callback()
  }

  static birthDate (rule, value, callback) {
    callback()
  }

  static phone (rule, value, callback) {
    const regex = /^(?:[\d]*)$/
    if (rule.required) {
      if (!value || typeof value === 'undefined') {
        callback(new Error(i18n.t('loyalty.requireField')))
      } else {
        if (value && typeof value === 'string' && !regex.test(value)) {
          callback(new Error(i18n.t('loyalty.invalidFormat')))
        } else {
          callback()
        }
      }
    } else {
      if (value && typeof value === 'string' && !regex.test(value)) {
        callback(new Error(i18n.t('loyalty.invalidFormat')))
      } else {
        callback()
      }
    }
  }

  static docId (rule, value, callback) {
    const regex = /^[A-Za-z0-9]+$/
    if (rule.required) {
      if (!value || typeof value === 'undefined') {
        callback(new Error(i18n.t('loyalty.requireField')))
      } else {
        if (value && typeof value === 'string' && !regex.test(value)) {
          callback(new Error(i18n.t('loyalty.notAllowedCharacters')))
        } else {
          callback()
        }
      }
    } else {
      if (value && typeof value === 'string' && !regex.test(value)) {
        callback(new Error(i18n.t('loyalty.notAllowedCharacters')))
      } else {
        callback()
      }
    }
  }

  static postalCode (rule, value, callback) {
    const regex = /^\d+$/
    if (rule.required) {
      if (!value || typeof value === 'undefined') {
        callback(new Error(i18n.t('loyalty.requireField')))
      } else {
        if (value && typeof value === 'string' && !regex.test(value)) {
          callback(new Error(i18n.t('loyalty.invalidFormat')))
        } else {
          callback()
        }
      }
    } else {
      if (value && typeof value === 'string' && !regex.test(value)) {
        callback(new Error(i18n.t('loyalty.invalidFormat')))
      } else {
        callback()
      }
    }
  }

  static regionCode (rule, value, callback) {
    const regex = /^\d+$/
    if (rule.required) {
      if (!value || typeof value === 'undefined') {
        callback(new Error(i18n.t('loyalty.requireField')))
      } else {
        if (value && typeof value === 'string' && !regex.test(value)) {
          callback(new Error(i18n.t('loyalty.invalidFormat')))
        } else {
          callback()
        }
      }
    } else {
      if (value && typeof value === 'string' && !regex.test(value)) {
        callback(new Error(i18n.t('loyalty.invalidFormat')))
      } else {
        callback()
      }
    }
  }

  static email (rule, value, callback) {
    const regex = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    if (rule.required) {
      if (!value || typeof value === 'undefined') {
        console.log(`1 ${rule.field}: [${value}] obligado: [${rule.required}] regExp: [${i18n.t('loyalty.requireField')}]`)
        callback(new Error(i18n.t('loyalty.requireField')))
      } else {
        if (value && typeof value === 'string' && !regex.test(value)) {
          console.log(`2 ${rule.field}: [${value}] obligado: [${rule.required}] regExp: [${i18n.t('loyalty.invalidFormat')}]`)
          callback(new Error(i18n.t('loyalty.invalidFormat')))
        } else {
          callback()
        }
      }
    } else {
      if (value && typeof value === 'string' && !regex.test(value)) {
        console.log(`3 ${rule.field}: [${value}] obligado: [${rule.required}] regExp: [${i18n.t('loyalty.invalidFormat')}]`)
        callback(new Error(i18n.t('loyalty.invalidFormat')))
      } else {
        callback()
      }
    }
  }
}

export { Validator }
